import { create } from 'zustand'

export interface NotificationItem {
  id: string
  titleKey: string
  bodyKey: string
  params: Record<string, string>
  level: 'info' | 'success' | 'warning' | 'error'
  timestamp: string
  read: boolean
}

interface NotificationStore {
  notifications: NotificationItem[]
  unreadCount: number
  addNotification: (item: Omit<NotificationItem, 'read'>) => void
  markAsRead: (id: string) => void
  markAllAsRead: () => void
  removeNotification: (id: string) => void
  clearAll: () => void
}

export const useNotificationStore = create<NotificationStore>((set, get) => ({
  notifications: [],
  unreadCount: 0,

  addNotification: (item) => set((state) => {
    const notification: NotificationItem = { ...item, read: false }
    const notifications = [notification, ...state.notifications].slice(0, 100)
    return {
      notifications,
      unreadCount: notifications.filter((n) => !n.read).length,
    }
  }),

  markAsRead: (id) => set((state) => {
    const notifications = state.notifications.map((n) =>
      n.id === id ? { ...n, read: true } : n
    )
    return {
      notifications,
      unreadCount: notifications.filter((n) => !n.read).length,
    }
  }),

  markAllAsRead: () => set((state) => ({
    notifications: state.notifications.map((n) => ({ ...n, read: true })),
    unreadCount: 0,
  })),

  removeNotification: (id) => set((state) => {
    const notifications = state.notifications.filter((n) => n.id !== id)
    return {
      notifications,
      unreadCount: notifications.filter((n) => !n.read).length,
    }
  }),

  clearAll: () => set({ notifications: [], unreadCount: 0 }),
}))
